import { O as spread_attributes } from "./index2.js";
function Button($$payload, $$props) {
  const {
    children,
    transparent = false,
    error = false,
    danger = false,
    disabled = false,
    outline = false,
    $$slots,
    $$events,
    ...props
  } = $$props;
  $$payload.out.push(`<button${spread_attributes({ disabled: error === true || disabled === true, ...props }, "svelte-7936pn", { outline, danger: danger || error, transparent })}>`);
  children($$payload);
  $$payload.out.push(`<!----></button>`);
}
export {
  Button as B
};
